import { InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { useState } from "react";
import { ReactComponent as CaretIcon } from "components/icons/dropdownArrowIcon.svg";
import { clsx } from "clsx";
import "./SortControl.scss";

interface ISortOptions {
  [key: string]: string;
}

export const SortControl = (props: {
  order: string;
  options: ISortOptions;
  onChange: (value: string) => void;
  label?: string;
  isNiche?: boolean;
}): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false);
  const label = props.label ?? "Sort by";

  const onChange = (event: SelectChangeEvent<string | unknown>) => {
    if (event.target.value !== undefined) {
      props.onChange(event.target.value as string);
    }
  };

  const getIcon = (): JSX.Element => {
    return (
      <div className="caret">
        <CaretIcon />
      </div>
    );
  };

  return (
    <div className="sortControl">
      <InputLabel>{label}</InputLabel>
      <Select
        className={clsx(["select", { "select--isOpen": isOpen }])}
        value={props.order}
        label={label}
        variant="outlined"
        onChange={onChange}
        IconComponent={getIcon}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
        MenuProps={{ className: clsx(["select-items", { isNiche: props.isNiche }]) }}
      >
        {Object.keys(props.options).map((key: string, index: number) => (
          <MenuItem
            key={index}
            value={key}
            className="sort-item"
          >
            {props.options[key]}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};
